<template>
	<div class="other_page_r">
		<el-card class="card_box">
			<div slot="header" class="card_title">
				<span>推荐管理/活动广告管理</span>
			</div>
			<div>
				<el-form
					:inline="true"
					:model="searchInfo"
					class="demo-form-inline margin_top_20 margin_left_20"
				>
					<el-form-item label="名称">
						<el-input
							class="custom_input_170"
							v-model="searchInfo.key"
							placeholder=""
						></el-input>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="searchBtn">查询</el-button>
						<el-button type="primary" @click="reset">重置</el-button>
						<el-button type="primary" @click="dialogFormVisible = true"
							>添加推荐</el-button
						>
					</el-form-item>
				</el-form>
			</div>
			<div class="table_box">
				<tablec :tableData="tableData"></tablec>
			</div>
			<div
				class="flex justify_content_end aligin_items_c table_footer custom_btn"
			>
				<div>
					<pagination
						v-show="total > 0"
						:total="total"
						:page.sync="searchInfo.page"
						:limit.sync="searchInfo.size"
						@pagination="getDataList"
					/>
				</div>
			</div>
		</el-card>
		<el-dialog
			title="添加活动首页calendar推荐位"
			:visible.sync="dialogFormVisible"
		>
			<el-form :model="form">
				<el-form-item label="活动id：" :label-width="formLabelWidth">
					<el-input
						v-model="form.id"
						autocomplete="off"
						style="width: 100px; margin-right: 20px"
					>
					</el-input>
					<el-button type="primary" @click="searchRecommend"> 查 询 </el-button>
				</el-form-item>
				<el-form-item label="活动名称：" :label-width="formLabelWidth">
					<el-input
						v-model="form.title"
						autocomplete="off"
						disabled="true"
					></el-input>
				</el-form-item>
				<el-form-item label="活动预览链接：" :label-width="formLabelWidth">
					<div class="pointer" v-if="form.id.length > 0" @click="showPreView()">
						https://www.me.news/events/{{ form.id }}
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="addRecommend"> 确 定 </el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import tablec from "./tablec.vue";
import {
	activitylists,
	detailsactivity,
	recommendactivity,
} from "@/api/article";
import { searchMixin } from "@/utils/searchMixin.js";
export default {
	components: { tablec },
	mixins: [searchMixin],
	name: "",
	data() {
		return {
			title: "活动新增",
			tableData: [],
			total: 0,
			dialogFormVisible: false,
			form: {
				title: "",
				id: "",
			},
			formLabelWidth: "120px",
			searchInfo: {
				page: 1,
				size: 10,
				is_calendar: 1,
				key: "",
			},
		};
	},
	created() {
		this.getDataList();
	},
	methods: {
		showPreView() {
			let url = "https://www.me.news/events/" + this.form.id;
			window.open(url, "预览");
		},
		searchBtn() {
			this.searchInfo.page = 1;
			this.getDataList();
		},
		searchRecommend() {
			const that = this;
			detailsactivity({ id: that.form.id })
				.then((res) => {
					if (res.code == 200) {
						that.form.title = res.data.title;
					} else {
						that.$message.error(res.message);
					}
				})
				.catch((error) => {
					that.$message.error(error.message);
				});
		},
		addRecommend() {
			this.dialogFormVisible = false;
			recommendactivity({ id: this.form.id, status: 1, key: "is_calendar" })
				.then((res) => {
					if (res.code == 200) {
						this.$message({
							type: "success",
							message: "添加推荐成功!",
						});
						this.getDataList();
					} else {
						this.$message.error(res.message);
					}
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},

		getDataList() {
			activitylists(this.searchInfo)
				.then((res) => {
					if (res.code == 200) {
						console.log(res.data.total);

						this.tableData = res.data.list;
						this.total = res.data.total;
					} else {
						this.tableData = [];
						this.total = 0;
					}
					this.loading = false;
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
	},
};
</script>

<style scoped></style>

<style>
.v-modal {
	z-index: -10 !important;
}
</style>
